import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

const PricingPage = () => {
    const navigate = useNavigate();

    const plans = [
        {
            id: 'free',
            name: 'Free',
            price: '$0',
            features: [
                'First 3 papers',
                'Access to all mindmaps',
                'Unlimited AI chat',
            ]
        },
        {
            id: 'pro',
            name: 'Pro',
            price: '$10/month',
            featured: true,
            features: [
                'Everything in Free',
                '10 papers per month',
                'Priority support',
            ]
        },
    ];

    return (
        <div className="min-h-screen bg-black text-white">
            <div className="max-w-6xl mx-auto px-6 py-24">
                <div className="text-center mb-16">
                    <h1 className="text-4xl font-bold mb-4">Simple, Transparent Pricing</h1>
                    <p className="text-xl text-gray-400">Choose the plan that's right for you</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
                    {plans.map((plan) => (
                        <div
                            key={plan.id}
                            className={`relative p-8 rounded-2xl border ${plan.featured
                                ? 'border-purple-500 bg-gradient-to-b from-purple-900/40 to-purple-900/20'
                                : 'border-purple-900/30 bg-purple-900/10'
                                } flex flex-col transform transition-all duration-200 hover:scale-105`}
                        >
                            {plan.featured && (
                                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                                    <span className="bg-purple-500 text-white text-xs font-semibold px-4 py-1 rounded-full">
                                        MOST POPULAR
                                    </span>
                                </div>
                            )}
                            <div className="mb-6">
                                <h3 className="text-xl font-bold text-white mb-2">{plan.name}</h3>
                                <div className="flex items-baseline">
                                    <span className="text-4xl font-bold text-purple-400">{plan.price}</span>
                                </div>
                            </div>
                            <ul className="flex-1 space-y-4 mb-8">
                                {plan.features.map((feature, index) => (
                                    <li key={index} className="flex items-center text-gray-300">
                                        <span className="mr-3 text-purple-400">
                                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                            </svg>
                                        </span>
                                        {feature}
                                    </li>
                                ))}
                            </ul>
                            <Button
                                onClick={() => navigate('/signup')}
                                className={`w-full py-4 text-base font-semibold transition-all duration-200 rounded-xl shadow-lg ${plan.featured
                                    ? 'bg-purple-500 hover:bg-purple-600 hover:shadow-purple-500/30 hover:-translate-y-0.5'
                                    : 'bg-purple-600/30 hover:bg-purple-600/50 hover:shadow-purple-600/20 hover:-translate-y-0.5'
                                    }`}
                            >
                                Get Started
                            </Button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PricingPage; 